import React, { useState, useEffect } from 'react'
import { superAxiosRequest } from 'axiosApi'
import { observer } from 'mobx-react'
import { localisationMaster } from 'Localisation/Localisation'
import asideModalStore from 'Stores/asideModalStore'
import FormFieldset from 'components/UI/AsideModal//Form/FormFieldset'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import InputFlagPhone from 'components/ContentBox/Global/InputPhone/InputFlagPhone/InputFlagPhone'
import BirthdaySelect from 'components/Modules/Auth/SignUp/BirthdaySelect/BirthdaySelect'
import Flex from 'components/UI/Flex/Flex'
import CheckboxToggle from '../../CheckboxToggle/CheckboxToggle'
import st from './AddUser.module.scss'

let apiConf
const Link = 'company/profiles'
const Tag = 'add_user'

const AddUser = () => {
  const genderList = [
    { id: 'M', name: localisationMaster('gender-1', Link, Tag) },
    { id: 'F', name: localisationMaster('gender-2', Link, Tag) },
  ]

  const { modalValues: ms, changeValue, check } = asideModalStore

  const [roleList, setroleList] = useState([{ id: 0, name: 'Выберите роль' }])

  useEffect(() => {
    // Роли
    apiConf = {
      method: 'get',
      link: 'accounts/roles',
    }
    superAxiosRequest(apiConf, 'data')
      .then((response) => {
        setroleList(response.data)
      })
      .catch(() => {})

    changeValue('12312300', 'password')
    changeValue(true, 'checked')
  }, [changeValue])

  useEffect(() => {
    // Обновление ссылки в конфиге модалки на основе выбранной роли
    const roleName = roleList.find((x) => x.id === ms.role)?.name
    if (roleName) {
      asideModalStore.config.link = 'accounts/employers/' + roleName
    }
  }, [ms.role, roleList])

  return (
    <FormFieldset>
      <div className={st.fieldSet}>
        <FormField>
          <FormLabel isRequired>Компания:</FormLabel>
          <SelectCustom
            placeholder='Компания'
            apiLink='db/companies'
            valueID={ms.company}
            onChange={(o) => changeValue(o.id, 'company')}
            error={check('company')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>Локация:</FormLabel>
          <SelectCustom
            placeholder='Локация'
            apiLink='db/locations'
            valueID={ms.location}
            onChange={(o) => changeValue(o.id, 'location')}
            error={check('location')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>Роль:</FormLabel>
          <SelectCustom
            placeholder='Роль'
            options={roleList}
            valueID={ms.role}
            onChange={(o) => changeValue(o.id, 'role')}
            error={check('role')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>Пол:</FormLabel>
          <SelectCustom
            placeholder='Выберите пол'
            options={genderList}
            valueID={ms.sex}
            onChange={(o) => changeValue(o.id, 'sex')}
            error={check('sex')}
          />
        </FormField>

        <FormField>
          <FormLabel isRequired>Фамилия:</FormLabel>
          <FormInput isError={check('last_name')}>
            <input
              placeholder={localisationMaster('input-placeholder-2', Link, Tag)}
              value={ms.last_name}
              onChange={(e) => changeValue(e.target.value, 'last_name')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel isRequired>Имя:</FormLabel>
          <FormInput isError={check('first_name')}>
            <input
              placeholder={localisationMaster('input-placeholder-1', Link, Tag)}
              value={ms.first_name}
              onChange={(e) => changeValue(e.target.value, 'first_name')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel>Отчество:</FormLabel>
          <FormInput>
            <input
              placeholder={localisationMaster('input-placeholder-3', Link, Tag)}
              value={ms.father_name}
              onChange={(e) => changeValue(e.target.value, 'father_name')}
            />
          </FormInput>
        </FormField>

        <FormField>
          <FormLabel>Дата рождения:</FormLabel>
          <FormInput>
            <BirthdaySelect
              error={check('date_of_birth')}
              value={ms.date_of_birth}
              onChange={(val) => changeValue(val, 'date_of_birth')}
            />
          </FormInput>
        </FormField>

        <FormField>
          <FormLabel>Телефон:</FormLabel>
          <FormInput>
            <InputFlagPhone
              error={check('mobile_phone')}
              value={ms?.mobile_phone || ''}
              onChange={(val) => changeValue(val, 'mobile_phone')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel isRequired>E-mail:</FormLabel>
          <FormInput isError={check('email')}>
            <input
              placeholder={localisationMaster('input-placeholder-4', Link, Tag)}
              value={ms.email}
              onChange={(e) =>
                changeValue(e.target.value.toLowerCase(), 'email')
              }
            />
          </FormInput>
        </FormField>
      </div>
      <FormField>
        <Flex>
          <CheckboxToggle
            right={localisationMaster('checkbox-info', Link, Tag)}
            checked={ms.checked || true}
            onChange={() => changeValue(!ms.checked, 'checked')}
          />
        </Flex>
      </FormField>

      <FormField>
        <FormLabel>Комментарий:</FormLabel>
        <FormInput>
          <textarea
            placeholder='Комментарий'
            value={ms.comment}
            onChange={(e) => changeValue(e.target.value, 'comment')}
          />
        </FormInput>
      </FormField>
    </FormFieldset>
  )
}

export default observer(AddUser)
